/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from 'react';
import RecommendCarCard from '@apps/components/RecommendCarCard';
import { PARENT_URL } from '@apps/config';
import getRecommendCarList from '@apps/config/API/recommend-car-list';
import EastIcon from '@mui/icons-material/East';
import { Stack, Typography } from '@mui/material';
import { useGetResponsive } from '@stack/helpers/lib/responsive';
import { TitleDivider } from '@stack/ui/components';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { AuthorsListingProps } from './props';
import { ContentWrapper, InnerContentWrapper, SectionWrapper } from './styles';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const RecommendCarList: React.FC<AuthorsListingProps> = (props) => {
  const { webView = false, onViewMore } = props;
  const router = useRouter();

  // ======================= HOOKS

  const { md: isMobile, lg: isTablet } = useGetResponsive();

  const [data, setData] = useState<any>();
  const [loading, setloading] = useState(false);

  const fetchData = async () => {
    try {
      setloading(true);
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth' as any,
        });
      }, 0);

      const res = await getRecommendCarList();

      if (res.data.length < 1) {
        router.replace(webView ? '/webview/404' : '/404');
        return;
      }
      setData(res?.data);
      setloading(false);
    } catch (err) {
      console.log('err', err);
    }
  };

  useEffect(() => {
    setData(null);
    fetchData();
  }, [router?.asPath, router?.locale]);

  // ======================= STATE

  // ======================= API

  // ======================= EVENTS

  // ======================= VARIABLES

  const slicedData = isMobile
    ? data?.slice(0, 2)
    : isTablet
    ? data?.slice(0, 3)
    : data?.slice(0, 4);

  // ======================= RENDER FUNCTIONS
  if (loading)
    return (
      <SectionWrapper>
        <ContentWrapper>
          {Array.from({ length: slicedData?.length || 2 }).map(
            (rd: any, index) => {
              return (
                <InnerContentWrapper
                  className="list-item custom-list-border"
                  key={index}
                >
                  <RecommendCarCard
                    tabletImagePosition="top"
                    simpleMobileView={true}
                    loading={loading}
                    webView={webView}
                    imageProps={{
                      src: '',
                      alt: '',
                    }}
                  />
                </InnerContentWrapper>
              );
            }
          )}
        </ContentWrapper>
      </SectionWrapper>
    );
  // ======================= VIEWS
  if (webView) return null;
  return (
    <Stack sx={{ pb: { xs: 6, md: 0 } }}>
      <TitleDivider title="Recommended For You" />
      <SectionWrapper>
        {data?.length > 0 && (
          <ContentWrapper
            style={{
              minHeight: loading ? '50vh' : 'unset',
            }}
          >
            {slicedData?.map((e: any, index: number) => {
              const item = {
                id: e?.ads_id,
                title: e?.ads_title,
                year: e?.car_manufacture_year,
                price: e?.ads_price,
                monthlyPayment: e?.ads_monthly_instalment,
                warranty: e?.ads_warranty_month / 12,
                mileage: e?.car_mileage_name,
                location: e?.location,
                slug: e?.ads_slug,
                is_automall: e?.is_automall,
              };
              return (
                <InnerContentWrapper
                  className="list-item custom-list-border"
                  key={index}
                >
                  <RecommendCarCard
                    imageProps={{
                      src: e?.ads_image_cover,
                      alt: e?.ads_title,
                      loading: 'lazy',
                      priority: false,
                      fetchPriority: 'auto',
                    }}
                    imagePosition="top"
                    tabletImagePosition="top"
                    mobileImagePostion="top"
                    maxImageWidth={'100%'}
                    loading={loading}
                    webView={webView}
                    data={item}
                  />
                </InnerContentWrapper>
              );
            })}
          </ContentWrapper>
        )}

        {!webView && (
          <Link
            href={`${PARENT_URL}/used-cars-for-sale`}
            onClick={() => {
              onViewMore
                ? onViewMore()
                : router.push(`${PARENT_URL}/used-cars-for-sale`);
            }}
          >
            <Stack
              spacing={1.5}
              direction="row"
              sx={{
                p: 2.5,
                alignItems: 'center',
                justifyContent: 'center',
                ':hover': {
                  backgroundColor: '#F7F7F7 !important',
                },
              }}
            >
              <Typography fontSize={16} fontWeight={700} textAlign={'center'}>
                Show More
              </Typography>
              <EastIcon sx={{ width: 20, height: 20, color: '#1E242F' }} />
            </Stack>
          </Link>
        )}
      </SectionWrapper>
    </Stack>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default RecommendCarList;
